import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: any) {
  }

  ngOnInit() {
  }

  backAway() {
    //if it was the first page
    if (history.length < 3) {
      this.document.location.href = '/';
    } else {
      history.back();
    }
  }

}
